import { useState } from "react";
import { ComponentCard } from "./components/ComponentCard";
import { ProjectComponents } from "./ProjectComponents";
import { Tabs } from "../components/Tabs";
import classes from "./Playground.module.less";

enum TabKey {
    Project = "Project",
}

const pageComponentsMap = new Map([[TabKey.Project, ProjectComponents]]);

export const Playground = () => {
    const [tab, setTab] = useState<TabKey>(TabKey.Project);
    const currentComponents = pageComponentsMap.get(tab);
    return (
        <div className={classes.playground}>
            <div className={classes.container}>
                <header className={classes.header}>
                    <h1>Component Playground</h1>
                    <p>Preview and test design system components</p>
                </header>
                <Tabs
                    activeKey={tab}
                    onChange={(key) => setTab(key as TabKey)}
                    items={[{ label: TabKey.Project, key: TabKey.Project }]}
                />
                {currentComponents?.map((item, index) => <ComponentCard {...item} key={index} />)}
            </div>
        </div>
    );
};
